/* ==========================================================================
   Blink Box - Product Details panel analytics
   Markup source: sections/product-details.liquid
========================================================================== */
(function () {
  'use strict';

  if (window.__blinkboxProductDetailsAnalyticsLoaded) return;
  window.__blinkboxProductDetailsAnalyticsLoaded = true;

  const SELECTORS = {
    section: '.cc-product-details',
    block: '.product-details__block',
    accordion: 'details-disclosure > details',
    summary: 'details-disclosure > details > summary',
    tabbedContent: 'tabbed-content',
    tab: '[role="tab"]'
  };

  const initialised = new WeakSet();

  function publishShopifyEvent(name, payload) {
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;

    try {
      const result = window.Shopify.analytics.publish(name, payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (error) {
      // Analytics must never interrupt product browsing.
    }
  }

  function sendGoogleEvent(name, params) {
    if (typeof window.gtag !== 'function') return;

    try {
      window.gtag('event', name, params);
    } catch (error) {
      // Google measurement is optional.
    }
  }

  function getProductHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getProductId() {
    return String(
      window.ShopifyAnalytics?.meta?.product?.id ||
      window.meta?.product?.id ||
      ''
    );
  }

  function getProductName() {
    return document
      .querySelector('.cc-main-product .product-title')
      ?.textContent
      ?.trim() || '';
  }

  function getVendor() {
    return document
      .querySelector('.cc-main-product .product-vendor')
      ?.textContent
      ?.trim() || '';
  }

  function normalisePanelKey(name) {
    return String(name || '')
      .replace(/\s*\([^)]*\)\s*$/, '')
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '') || 'unknown';
  }

  function buildPayload(displayStyle, panelName, panelPosition) {
    return {
      display_style: displayStyle,
      panel_key: normalisePanelKey(panelName),
      panel_name: panelName,
      panel_position: panelPosition,
      source_product_id: getProductId(),
      source_product_name: getProductName(),
      source_product_handle: getProductHandle(),
      vendor: getVendor()
    };
  }

  function trackPanelSelect(displayStyle, panelName, panelPosition) {
    const payload = buildPayload(
      displayStyle,
      panelName,
      panelPosition
    );

    publishShopifyEvent(
      'blinkbox_product_details_panel_select',
      payload
    );

    sendGoogleEvent(
      'product_details_panel_select',
      payload
    );
  }

  function getAccordionName(details) {
    return details
      .querySelector(':scope > summary .disclosure__title')
      ?.textContent
      ?.trim() || 'Unknown';
  }

  function getTabName(tab) {
    return tab.textContent?.trim() || 'Unknown';
  }

  function getPosition(items, selected) {
    return Array.from(items).indexOf(selected) + 1;
  }

  function initAccordionBlock(block) {
    const accordions = block.querySelectorAll(SELECTORS.accordion);
    if (!accordions.length) return false;

    block.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const summary = event.target.closest(SELECTORS.summary);
      if (!summary || !block.contains(summary)) return;

      const details = summary.closest('details');
      if (!details || details.open) return;

      const currentAccordions = block.querySelectorAll(SELECTORS.accordion);

      trackPanelSelect(
        'accordion',
        getAccordionName(details),
        getPosition(currentAccordions, details)
      );
    }, true);

    return true;
  }

  function initTabsBlock(block) {
    const tabbedContent = block.querySelector(SELECTORS.tabbedContent);
    if (!tabbedContent) return false;

    block.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const tab = event.target.closest(SELECTORS.tab);
      if (!tab || !tabbedContent.contains(tab)) return;

      if (tab.getAttribute('aria-selected') === 'true') return;

      const tabs = tabbedContent.querySelectorAll(SELECTORS.tab);

      trackPanelSelect(
        'tabs',
        getTabName(tab),
        getPosition(tabs, tab)
      );
    }, true);

    return true;
  }

  function initBlock(block) {
    if (!block || initialised.has(block)) return;

    const hasTabs = initTabsBlock(block);
    const hasAccordions = hasTabs ? false : initAccordionBlock(block);

    if (!hasTabs && !hasAccordions) return;

    initialised.add(block);
    block.dataset.productDetailsAnalyticsInitialised = 'true';
  }

  function boot(scope) {
    const container = scope || document;

    container
      .querySelectorAll?.(`${SELECTORS.section} ${SELECTORS.block}`)
      .forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
